export const normalizeUrl = (input: string): string => {
  if (!input.trim()) return input;

  const trimmed = input.trim();

  if (/^https?:\/\//i.test(trimmed)) {
    return trimmed;
  }

  if (
    /^www\./i.test(trimmed) ||
    /^[\da-z-]+\.[a-z]{2,}/i.test(trimmed) ||
    (trimmed.includes(".") && !trimmed.includes(" "))
  ) {
    return `https://${trimmed}`;
  }

  return trimmed;
};
